<template>
    <div class="container" :class="type === 'document' ? 'document_container' : ''">
        <el-input
            v-if="type === 'addFile'"
            prefix-icon="el-icon-search"
            @input="getFileByName"
            v-model="searchText"
            :placeholder="$t('common.请输入')"
            type="text"
        ></el-input>
        <div class="doc_tree">
            <div class="file_nav" v-show="navFlag">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item @click.native="fileAll">
                        <span class="Major_Color Cursor_P">{{$t('documentLibrary.全部文件')}}</span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item v-for="(i,ind) in fileArr" :key="ind">
                        <span
                            class="Minor_Color Cursor_P Text_Over"
                            style="max-width:150px;"
                            @click.stop="fileNavFn(i,ind)"
                        >{{i.name}}</span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-table
                :data="list"
                :row-class-name="tableRowClassName"
                style="width: 100%"
                height="100%"
                @row-click="handleChange"
            >
                <template #empty>
                    <cl-no-data v-show="tableLoading" img-type="file"></cl-no-data>
                </template>

                <el-table-column
                    :label="$t('documentLibrary.文件名')"
                    :width="type==='addFile' ? 310 : 420"
                >
                    <template slot-scope="scope">
                        <div class="Disp_AC">
                            <el-checkbox
                                style="min-width: 20px;width: 20px; height:20px"
                                class="Custom_Check mr38"
                                v-show="type === 'addFile' && scope.row.type !== 2"
                                @change="handleChange(scope.row)"
                                v-model="scope.row.checked"
                            ></el-checkbox>
                            <!--文档库选择-->
                            <el-checkbox
                                style="min-width: 20px;width: 20px; height:20px;margin-right: 36px "
                                class="Custom_Check"
                                v-show="type === 'document'"
                                @change="checkedGn(scope.row,'change')"
                                v-model="scope.row.checked"
                            ></el-checkbox>
                            <div
                                class="Disp_AC Cursor_P"
                                @click="!scope.row.editChecked ? fileClickFn(scope.row) : ''"
                            >
                                <cl-svg-icon
                                    v-if="scope.row.type==2"
                                    width="30"
                                    height="35"
                                    :currentColor="false"
                                    icon-class="tu_file_folder"
                                ></cl-svg-icon>
                                <cl-svg-icon
                                    v-else
                                    width="30"
                                    height="35"
                                    :currentColor="false"
                                    :icon-class="`tu_file_${$utils.formatSuffix(scope.row.name)}`"
                                ></cl-svg-icon>
                                <el-tooltip
                                    v-if="!scope.row.editChecked"
                                    class="item"
                                    effect="dark"
                                    :content="scope.row.name"
                                    placement="top"
                                >
                                    <span
                                        class="ml8 Text_Over"
                                        style="max-width:280px;"
                                    >{{scope.row.name}}</span>
                                </el-tooltip>
                                <!--                                文档库修改文件夹名称-->
                                <el-input
                                    v-else
                                    type="type"
                                    class="table__select w150 input__bold fl"
                                    :placeholder="$t('common.请填写',$store.state.language)"
                                    v-model="scope.row.name"
                                ></el-input>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('documentLibrary.大小')">
                    <template slot-scope="scope">
                        <span class="size">{{scope.row.size || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('documentLibrary.创建人')">
                    <template slot-scope="scope">
                        <span class="creator">{{scope.row['userName' + $lang] || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('documentLibrary.修改时间')">
                    <template slot-scope="scope">
                        <span
                            class="size"
                        >{{$utils.formatTime('YYYY/MM/DD HH:mm', scope.row.updateTime) || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label width="150" align="left" v-if="type === 'document'">
                    <template slot-scope="{row}">
                        <div class="operation Table_Operation" v-if="isShowMove">
                            <!-- 编辑 -->
                            <div
                                v-if="!row.editChecked && row.type===2"
                                class="mr24 edit"
                                @click.stop="edit(row,$event)"
                            >
                                <cl-svg-icon width="24" icon-class="tu_comment_edit" />
                            </div>
                            <div
                                v-if="row.editChecked  && row.type===2"
                                class="mr24 edit"
                                @click.stop="save(row,$event)"
                            >
                                <cl-svg-icon width="24" icon-class="edit_done" />
                            </div>
                            <!-- 移动到 -->
                            <div
                                class="mr24 edit"
                                v-if="isShowMove"
                                @click.stop="checkedGn(row,'click')"
                            >
                                <cl-svg-icon
                                    width="24"
                                    :color="row.editChecked ? '#B7B7BF' : '#ffffff'"
                                    icon-class="document_move"
                                />
                            </div>
                            <!-- 删除 -->
                            <div v-if="row.type!==2" @click.stop="del(row)" class="del">
                                <cl-svg-icon
                                    width="24"
                                    :icon-class="row.editChecked ? 'delete' : 'tu_comment_delete'"
                                />
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 图片弹窗 -->
        <el-dialog
            :title="$t('schedule.预览')"
            :visible.sync="imgDialogVisible"
            width="80%"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div class="preview">
                <img v-if="imageUrl" :src="imageUrl" alt />
                <video v-if="videoURL" width="100%" :src="videoURL" controls></video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/**
 * ComponentName: file tree
 * Created Date:2022/4/29
 * Author: Nancy
 * Modify: xinxin·song 2022/5/16
 * 组件说明：
 * 传入文件列表，将文件列树显示
 * eg:
 *     <cl-file-tree v-model="list"></cl-file-tree>
 */
export default {
    name: 'cl-file-tree',
    data () {
        return {
            searchText: '', // 搜索文字
            selectedList: this.value || [], // 选择的文件

            list: [], //文件列表

            navFlag: false, //是否显示文件导航
            fileArr: [], // 文件导航列表
            imgDialogVisible: false, // 图片弹窗
            imageUrl: '', // 图片的地址
            videoURL: '', // 视频地址
            getEvent: null,//表格编辑选中行
            tableLoading: false,
            isShowMove: false,
        };
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        //引用类型 addFile 添加文件引用 document 文档库列表引用
        type: {
            type: String,
            default: 'addFile'
        },
        //    搜索名称
        searchFile: {
            type: String,
            default: ''
        },
        //   初始化状态
        initState: {
            type: String,
            default: ''
        },
        // 需要展示的文件格式
        accept: {
            type: String,
            default: ''
        },
        /* 选择文档库文件 */
        checkDocumentList: {
            type: Array,
            default: () => []
        },
    },
    watch: {
        value: {
            handler () {
                this.selectedList = JSON.parse(JSON.stringify(this.value));
            },
            deep: true,
        },
        //搜索名称
        searchFile: {
            handler (val) {
                this.searchText = '';
                this.searchText = val;
                val ? this.getFileByName() : this.getFileData(false);
            },
        },
        //初始化列表
        initState: {
            handler (val) {
                // console.log(val);
                if (val === 'init') {
                    this.fileArr.length ? this.getFileData(true) : this.getFileData(false);
                }
            },
        },
        //文件导航列表
        fileArr: {
            handler (val) {
                this.$emit('fileArrData', val)
            },
            deep: true,
        },
        checkDocumentList: {
            deep: true,
            handler (newV) {
                this.isShowMove = newV.length > 1 ? false : true

            }
        },
    },

    computed: {},

    mounted () {
        this.getFileData(false);
    },

    methods: {
        //更改表格class
        tableRowClassName ({ row }) {
            if (this.type === 'addFile') return '';
            return row.checked ? 'checked' : '';
        },
        //编辑
        edit (row, event) {
            this.list.forEach(item => {
                row.id === item.id ? item.editChecked = true : item.editChecked = false;
            });
            this.$utils.rowFn(event);
            this.getEvent = event;
        },
        //编辑名称保存
        save (row, event) {
            this.$utils.rowFn(event, 'empty');
            this.getEvent = null;
            let data = {
                documentsId: row.id,
                name: row.name
            };
            this.$server.updateDocumentFolder(data)
                .then(() => {
                    this.$message({
                        type: "success",
                        message: this.$t("message.保存成功")
                    });
                    this.list.forEach(item => {
                        item.editChecked = false;
                    });
                    this.fileArr.length ? this.getFileData(true) : this.getFileData(false);
                })
        },
        //删除文件
        del (row) {
            if (row.userId !== this.$store.state.userData.id) {
                this.$message.warning(this.$t('documentLibrary.仅可删除本人上传的文件'));
                return
            }
            const h = this.$createElement;
            const msg = this.$t("common.您确定要删除");
            this.$confirm('', '',
                {
                    message: h('p', null, [
                        h('span', {}, `${msg}“`),
                        h('span', { style: 'color:#3663E1;' }, `${row.name}`),
                        h('span', {}, `”？`)
                    ]),
                    confirmButtonText: this.$t("common.确定"),
                    cancelButtonText: this.$t("common.取消"),
                    type: "warning",
                }).then(async () => {
                    const params = {
                        documentsId: row.id,
                        userId: row.userId
                    };
                    let res = await this.$server.documentsDelete(params);
                    // console.log(res);
                    if (res.code === 200) {
                        this.$message.success(this.$t("message.删除成功"));
                        this.fileArr.length ? this.getFileData(true) : this.getFileData(false);
                    }
                }).catch(() => { });
        },
        // 通过文件名筛选文件列表
        getFileByName () {
            this.list = []
            this.$server.getDocumentSearch({
                name: this.searchText
            }).then(res => {
                this.$emit('closeList'); //关闭上传列表
                this.navFlag = false;
                this.fileArr = [];

                let list = this.setData(res.data);
                this.list = list.map(row => {
                    let itm = this.selectedList.find(el => el.id === row.id);
                    return {
                        ...row,
                        checked: itm ? true : false
                    }
                });
                this.tableLoading = this.list && this.list.length ? false : true;
            })
        },
        // 设置数据
        setData (data) {
            // 筛选需要的文件类型
            let list = [];
            if (this.accept.length) {
                data.forEach(item => {
                    if (item.type === 2) { // 文件夹不处理
                        list.push(item)
                    } else { // 文件格式进行筛选
                        let suffix = this.$utils.formatSuffix(item.name);
                        if (this.accept.indexOf(suffix) !== -1) {
                            list.push(item)
                        }
                    }
                })
            } else {
                list = data;
            }
            return list;
        },
        // 获取文件树数据
        getFileData (flag) {
            let data = {}
            if (this.fileArr.length) {
                data['parentId'] = this.fileArr[this.fileArr.length - 1].id; //文件夹--父级id
            }
            this.$server.getDocumentList(data).then((res) => {
                this.navFlag = flag;
                let list = this.setData(res.data);

                this.list = list.map(row => {
                    let itm = this.selectedList.find(el => el.id === row.id);
                    return {
                        ...row,
                        checked: itm ? true : false,
                        editChecked: false //编辑状态
                    }
                });
                this.tableLoading = this.list && this.list.length ? false : true;
                //父组件回到全部页面初始化数据
                if (!flag) {
                    this.$emit('init');
                    this.searchText = '';
                }

            })
        },
        //点击文件夹
        fileClickFn (item) {
            //如果有编辑未关闭选中表格的行进行清除  清除后进行重置选中行
            this.getEvent ? this.$utils.rowFn(this.getEvent, 'empty') : '';
            this.getEvent = null;
            this.$emit('closeList'); //关闭上传列表
            if (item.type == 2) {
                this.fileArr.push(item);
                this.getFileData(true);
            } else {
                //只有文档库能预览图片视频
                if (this.type === 'document') {
                    this.videoURL = '';
                    this.imageUrl = '';
                    let suffix = this.$utils.formatSuffix(item.name);
                    let videoType = ['mp4', 'mov'];
                    let imgType = ['jpg', 'jpeg', 'png', 'svg'];
                    if (videoType.includes(suffix)) {
                        this.videoURL = item.url;
                        this.imgDialogVisible = true;
                    }
                    if (imgType.includes(suffix)) {
                        this.imageUrl = item.url;
                        this.imgDialogVisible = true;
                    }
                }
            }
        },
        //点击面包屑--跳转对应的层级
        fileNavFn (fileItem, ind) {
            //如果有编辑未关闭选中表格的行进行清除  清除后进行重置选中行
            this.getEvent ? this.$utils.rowFn(this.getEvent, 'empty') : '';
            this.getEvent = null;
            if (ind == this.fileArr.length - 1) return;
            this.fileArr = this.fileArr.slice(0, ind + 1);
            this.getFileData(true);
        },
        //点击面包屑--全部文件/返回到初始页
        fileAll () {
            if (this.fileArr.length) {
                this.fileArr = [];
                //如果有编辑未关闭选中表格的行进行清除  清除后进行重置选中行
                this.getEvent ? this.$utils.rowFn(this.getEvent, 'empty') : ''; //表格编辑选中行
                this.getEvent = null;
                this.getFileData(false);
            }
        },
        // 选择
        handleChange (item) {
            if (item.type == 2 || this.type === 'document') { // 文件夹return
                return
            }
            item.checked = !item.checked
            let index = this.selectedList.findIndex(el => el.id === item.id);
            if (item.checked) { // 选择
                if (index === -1) { // 添加
                    this.selectedList.push(item);
                }
            } else { // 取消
                if (index !== -1) { // 删除
                    this.selectedList.splice(index, 1);
                }
            }
            this.$emit('change', this.selectedList);
        },
        // 文档库移动选择
        checkedGn (item, type) {
            this.$emit('checkedGn', item, type);
        }
    }
}
</script>
<style lang='scss' scoped>
.container {
    width: 100%;
    height: 436px;

    .doc_tree {
        height: calc(100% - 40px);
        position: relative;

        .file_nav {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            height: 46px;
            width: 100%;
            background-color: #fff;
            display: flex;
            align-items: center;
        }
    }
}
.size {
    font-size: 16px;
    font-family: AkrobatRegular;
}

/deep/ .el-table th.el-table__cell > .cell {
    padding-left: 14px;
}

/*文档库样式*/
.document_container {
    height: 100%;
    .doc_tree {
        height: 100%;
    }
    /deep/ .el-table th.el-table__cell > .cell {
        font-size: 14px;
    }
    /deep/.el-table th.el-table__cell {
        &:first-child {
            > .cell {
                box-sizing: border-box;
                padding-left: 100px;
            }
        }
    }
}
.operation {
    display: flex;
    justify-content: left;
    align-items: center;
    // .edit:hover{

    // }
}
.preview {
    width: 100%;
    height: 568px;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 98%;
        max-height: 540px;
        margin: 0 auto;
    }
}
</style>
